import { FC, useMemo, useCallback } from 'react'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FloatingPane } from 'interfaces/floatingPanes'
import { FutureLayerDetailsPane } from 'components/features/future/FutureLayerDetailsPane/FutureLayerDetailsPane'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { FutureAssumptionsPane } from 'components/features/future/FutureAssumptionsPane/FutureAssumptionsPane'
import { FutureMemberLayersPane } from 'components/features/future/FutureMemberLayersPane/FutureMemberLayersPane'
import { FutureAllLayersPane } from 'components/features/future/FutureAllLayersPane/FutureAllLayersPane'

const TYPED_PANE = {
  type: 'future' as const,
}

type FutureFloatingPaneProps = {

}

export const FutureFloatingPane: FC<FutureFloatingPaneProps> = (props) => {
  const {} = props

  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, TYPED_PANE)) as Extract<FloatingPane, typeof TYPED_PANE>

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
  }, [dispatch])

  return useMemo(() => {
    switch (pane.mode) {
      case 'assumptions': {
        return (
          <FutureAssumptionsPane onCancel={ handleClose } />
        )
      }
      case 'member-layers': {
        return (
          <FutureMemberLayersPane onCancel={ handleClose } />
        )
      }
      case 'all-layers': {
        return (
          <FutureAllLayersPane onCancel={ handleClose } />
        )
      }
      case 'layer-details': {
        return (
          <FutureLayerDetailsPane onCancel={ handleClose } uid={ pane.uid } slug={ pane.slug } />
        )
      }
    }

    return null
  }, [handleClose, pane])
}
